import React, { useState, useEffect, Fragment } from 'react';
import { useParams } from "react-router-dom";
import { Container, Row, Col } from 'react-bootstrap';
import Moment from 'react-moment';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import './user.css'

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.paper,
        width: 500,
    },
    gridList: {
        width: 500,
        height: 450,
    },
}));
export default function User() {

    let { id } = useParams();

    const [userId, setUserId] = useState()
    const [email, setEmail] = useState()
    const [name, setName] = useState()
    const [surname, setSurname] = useState()
    const [level, setLevel] = useState()
    const [position, setPosition] = useState()
    const [nb_participate, setNbParticipate] = useState()

    const [value, setValue] = useState(0)
    const theme = useTheme();

    useEffect(() => {

        fetch('https://playattitude.fr/admin/user/' + id, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'Bearer ' + localStorage.getItem('web_bm')
            })
        }).then(res => res.json())
            .then(res => {
                setUserId(res[0].id)
                setEmail(res[0].email)
                setName(res[0].name || '')
                setSurname(res[0].surname  || '')
                setPosition(res[0].favorite_position  || '')
                setLevel(res[0].level)
                setNbParticipate(res[0].nb_participate)
            })
    }, [])

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const handleChangeIndex = index => {
        setValue(index);
    };

    function updateUser(){
        console.log('totootot')
        fetch('https://playattitude.fr/admin/user/update', {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'Bearer ' + localStorage.getItem('web_bm')
            }),
            body: JSON.stringify({
                user_id: userId, 
                params: {
                    email: email,
                    name: name,
                    surname:surname,
                    level: level,
                    // favorite_position: position
                }
            })
    })
    .then(res => {
        console.log(res)
    }) 
}




    return (
        <div id="user">
            <AppBar position="static">
                <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" centered>
                    <Tab label="Détail" {...a11yProps(0)} />
                    <Tab label="Edition" {...a11yProps(1)} />
                </Tabs>
            </AppBar>
            <SwipeableViews
                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                index={value}
                onChangeIndex={handleChangeIndex}
            >
                <TabPanel value={value} index={0}>
                    <Container>
                        <Row>
                            <Col>
                                <Row>
                                    <Col>
                                        <h2>Détails du compte</h2>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <p><strong>Email :</strong> {email}</p>
                                    </Col>

                                </Row>
                                <Row>
                                    <Col>
                                        <p><strong>Nom :</strong> {name}</p>
                                    </Col>
                                    <Col>
                                        <p><strong>Prénom :</strong> {surname}</p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <p><strong>Niveau :</strong> {level}</p>
                                    </Col>
                                    <Col>
                                        <p><strong>Position :</strong> {position}</p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <p><strong>Nombre de réservation faite :</strong>{nb_participate}</p>
                                    </Col>
                                </Row>


                            </Col>

                        </Row>
                    </Container>
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <Container>
                        <Row>
                            <Col>
                                <Row>
                                    <Col>
                                        <h2>Edition du compte</h2>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <TextField id="email" label="Email" variant="outlined" value={email} onChange={(e) => setEmail(e.target.value)} />
                                    </Col>

                                </Row>
                                <Row>
                                    <Col>
                                        <TextField id="name" label="Nom" variant="outlined" value={name} onChange={(e) => setName(e.target.value)} />
                                    </Col>
                                    <Col>
                                        <TextField id="surname" label="Prénom" variant="outlined" value={surname} onChange={(e) => setSurname(e.target.value)} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <FormControl variant="outlined">
                                            <InputLabel id="demo-simple-select-outlined-label">Niveau</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-outlined-label"
                                                id="demo-simple-select-outlined"
                                                value={level}
                                                onChange={(e) => setLevel(e.target.value)}
                                                label="Niveau"
                                            >
                                                <MenuItem value={"Débutant"}>Débutant</MenuItem>
                                                <MenuItem value={"Intermédiaire"}>Intermédiaire</MenuItem>
                                                <MenuItem value={"Confirmé"}>Confirmé</MenuItem>
                                                <MenuItem value={"Avancé"}>Avancé</MenuItem>
                                                <MenuItem value={"Expert"}>Expert</MenuItem>

                                            </Select>
                                        </FormControl>
                                    </Col>
                                    {/* <Col>
                                        <TextField id="poste" label="Poste" variant="outlined" value={position} onChange={(e) => setEmail(e.target.position)} />
                                    </Col> */}
                                </Row>
                                <Row>
                                    <Col>
                                        <Button variant="contained" color="primary" onClick={() => {updateUser()}}>
                                            Sauvegarder les modofications
                                        </Button>
                                    </Col>
                                </Row>


                            </Col>

                        </Row>
                    </Container>
                </TabPanel>


            </SwipeableViews>
        </div>
    );
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </Typography>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}